export const routes = Object.freeze({
  home: "/",
  notFound: "/not-found",
  games: "/games",
  gamesTop: "/games/top",
  gamesNew: "/games/new",
  gamesSlots: "/games/slots",
  gamesRoulette: "/games/roulette",
  gamesBlackjack: "/games/blackjack",
  gamesPoker: "/games/poker",
  gamesLiveCasino: "/games/live-casino",
  gamesInstant: "/games/instant",
  game: "/game",
  providers: "/providers",
  provider: "/provider",
  favorites: "/favorites",
  profile: "/profile",
  profileEdit: "/profile/edit",
  profileHistory: "/profile/history",
  profileVerification: "/profile/verification",
  profilePromotions: "/profile/promotions",
  promotions: "/promotions",
  bonuses: "/bonuses",
} as const);

export const publicRoutes: string[] = [routes.home, routes.notFound];

export const knownRoutes: string[] = [...Object.values(routes)];

export const PRIVATE_DEFAULT_ROUTE = "";

export const PUBLIC_DEFAULT_ROUTE = routes.home;
